export enum ExternalQueryParam {
  REGISTRATION_TYPE = 'registration_type',
  WELCOME = 'welcome',
}